import { NavLink } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-ink text-white py-12 md:py-16 px-4">
      <div className="container-site mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <strong className="block text-xl sm:text-2xl font-extrabold">MH-BETON</strong>
            <span className="block text-white/70 text-sm mt-2 max-w-md">
              Betontransport, Betonverkauf und Betonpumpenvermietung mit Fahrer.
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 font-bold text-sm">
            <NavLink to="/impressum" className="hover:text-signal transition-colors min-h-11 flex items-center">
              Impressum
            </NavLink>
            <NavLink to="/datenschutz" className="hover:text-signal transition-colors min-h-11 flex items-center">
              Datenschutz
            </NavLink>
            <a
              href="https://www.tiktok.com/@mhbeton"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-signal transition-colors min-h-11 flex items-center"
            >
              TikTok
            </a>
            <a
              href="mailto:office@mh-beton.at"
              className="hover:text-signal transition-colors min-h-11 flex items-center"
            >
              E-Mail
            </a>
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 text-white/50 text-xs">
          &copy; {new Date().getFullYear()} MH-BETON. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
